import React from 'react';
import styled from 'styled-components';
import IWidget from '../iwidget';
import { Icon } from 'office-ui-fabric-react';

import { theme } from 'theme';
import {
  DefaultButton,
  DetailsList,
  ISearchBox,
  PrimaryButton,
  SearchBox,
  Selection,
  Spinner,
} from 'office-ui-fabric-react';
import Modal from 'views/components/UI/DefaultModal';
import { ViewSelection } from 'views/components/UI/ViewSelection';

import {
  getList as getListRequest,
  widgetAddCameraVehicle
}                   from 'api/handbooks/table';
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const SearchBoxWrapper = styled.div`
  padding: 20px 25px;
  background: #ffffff;
`;

const Status = styled.div<{ isOnline: boolean }>`
  position: relative;
  display: inline-block;

  :before {
    content: '';
    display: block;
    position: absolute;
    top: 5px;
    left: -10px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${(props) => (props.isOnline ? '#7FBA00' : '#CDCDCD')};
  }
`;

const FilterPicker = styled.div`
  width: 320px;
  max-height: 315px;
  min-height: 315px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;

  .ms-Check.is-checked {
    :before {
      background: ${theme.colors.lightBlue};
    }
  }

  .ms-DetailsRow {
    min-width: 100% !important;
  }
`;

const ErrorMessage = styled.div`
  font-size: 21px;
  font-weight: normal;
  color: #5f5d5b;
  margin: 58px 0 77px;
  text-align: center;
`;

const StyledFooter = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 70px;
  background: #ffffff;

  button:first-child {
    background: ${theme.colors.lightBlue};
  }
`;

interface IProps {
  onClose: () => void;
  onRefresh?: () => void;
}

interface IState {
  searchFieldValue: string;
  items: Array<any>;
  filteredItems: Array<any>;
  isLoading: boolean;
}

class VehicleFilterModal extends React.Component<IProps, IState> {
  private selection: Selection = new Selection({
    onSelectionChanged: () => {

      // this.compareSelection(
      //   this.state.videoSelection,
      //   this.selection!.getSelection() as IVideoListItem[]
      // );
    },
  });
  private searchBox: React.RefObject<ISearchBox>;

  constructor(props: IProps) {
    super(props);

    this.state = {
      searchFieldValue: '',
      items: [],
      filteredItems: [],
      isLoading: true,
    };

    this.searchBox = React.createRef<ISearchBox>();
  }

  componentDidMount(): void {
    if (this.searchBox.current) {
      this.searchBox.current.focus();
    }
    this.loadVehicles();
  }

  loadVehicles = async () => {
    const vehicles = await getListRequest({
      schema: 'mgt',
      table: 'Vehicle',
      fields: ['vehicle_id', 'depot_number'],
      sort: {
        field: 'depot_number',
        direction: 'asc'
      },
      apiType: apiTypes.DEFAULT,
    });
    const vehData = ((vehicles && vehicles.list) || []).map((el: any) => ({ key: el.vehicle_id, primaryField: el.depot_number}));
    this.setState({
      isLoading: false,
      items: vehData,
      filteredItems: vehData
    });
  }


  setSelectedItems = () => {

  };

  handleSearchFieldChange = (newValue: string) => {
    const filteredItems = newValue
      ? this.state.items.filter((item) => {
          return (
            item &&
            item.primaryField &&
            item.primaryField
              .toString()
              .toLocaleLowerCase()
              .includes(newValue.toLocaleLowerCase())
          );
        })
      : this.state.items;
    this.setState({
      filteredItems,
      searchFieldValue: newValue,
    });
  };

  onCreate = async () => {
    const vehIds: string[] = this.selection.getSelection().map((sel) => sel.key ? sel.key.toString(): '');
    await widgetAddCameraVehicle(vehIds);
    this.props.onRefresh && this.props.onRefresh();
    this.props.onClose && this.props.onClose();
  }

  render() {
    const { onClose } = this.props;

    const { searchFieldValue, filteredItems } = this.state;

    return (
      <>
        <Modal handleClose={onClose} title={'Добавить ТС'}>
          <SearchBoxWrapper>
            <SearchBox
              onChange={this.handleSearchFieldChange}
              value={searchFieldValue}
              componentRef={this.searchBox}
            />
          </SearchBoxWrapper>
          <FilterPicker>
            {!this.state.isLoading ? (
              <>
                <ViewSelection selection={this.selection} items={filteredItems}>
                  <DetailsList
                    items={filteredItems}
                    isHeaderVisible={false}
                    selection={this.selection}
                    columns={[
                      {
                        name: 'primaryField',
                        fieldName: 'primaryField',
                        key: 'primaryField',
                        minWidth: 0,
                      },
                    ]}
                    setKey={'set'}
                    selectionPreservedOnEmptyClick
                    onRenderItemColumn={this.renderItemColumn}
                  />
                </ViewSelection>
                {!searchFieldValue || filteredItems.length ? null : (
                  <ErrorMessage>Ничего не найденно</ErrorMessage>
                )}
              </>
            ) : (
              <Spinner
                styles={{
                  root: {
                    position: 'relative',
                    minHeight: 300,
                    maxHeight: 300,
                    marginLeft: 25,
                  },
                  circle: {
                    position: 'absolute',
                    transform: 'translateY(-50%)',
                    top: '50%',
                  },
                  label: {
                    position: 'absolute',
                    transform: 'translateY(-50%)',
                    top: '60%',
                  },
                }}
                size={3}
                label={'Загрузка'}
              />
            )}
          </FilterPicker>
          <StyledFooter>
            <PrimaryButton
              onClick={this.onCreate}
            >
              Выбрать
            </PrimaryButton>
            <DefaultButton
              onClick={() => {
                // onFilter(null, this.props.title);
                onClose();
              }}
            >
              Отменить
            </DefaultButton>
          </StyledFooter>
        </Modal>
      </>
    );
  }

   renderItemColumn = (item: any) => {
    const fieldContent = item.primaryField as string;
    return <span>{fieldContent}</span>;
  };
}





class CameraAddVehicle implements IWidget {
  key = 'cameraAdd_widget';
  name = 'Добавить ТС';
  iconProps = { iconName: 'Add' };
  onStateChange?: () => void = undefined;
  onWidgetRefresh?: () => void = undefined;
  onClick = () => {
    this.isShow = true;
    this.onStateChange && this.onStateChange!();
  };
  isShow: boolean = false;
  onClose = () => {
    this.isShow = false;
    this.onStateChange && this.onStateChange!();
  }
  component = () => {
    return this.isShow ? <VehicleFilterModal onClose={this.onClose} onRefresh={this.onWidgetRefresh} /> : null;
  }
}

export default new CameraAddVehicle();
